import api from '@/common/api.js'

export default {
  namespaced: true,

  state: {
    items: [],
    editing: {},
    itemsExec: {},
    itemsPreventiva: {},
    allItems: {},
    placasAVencer: {},
    totalplacasAVencer: {},
    totalplacasAVencerArmazem: {},
    totalPlacasVencidas: {},
    totalPlacasVencidasArmazem: {},
    setCarroceriasPreventivas: null,
    setTotalCarroceriasAVencer: 0,
    setTotalCarroceriasVencidas: 0
  },

  getters: {
    items: (state) => state.items,
    itemsPreventiva: (state) => state.itemsPreventiva,
    editing: (state) => state.editing,
    itemsExec: (state) => state.itemsExec,
    allItems: (state) => state.allItems,
    placasAVencer: (state) => state.placasAVencer,
    totalplacasAVencer: (state) => state.totalplacasAVencer,
    totalplacasAVencerArmazem: (state) => state.totalplacasAVencerArmazem,
    totalPlacasVencidas: (state) => state.totalPlacasVencidas,
    totalPlacasVencidasArmazem: (state) => state.totalPlacasVencidasArmazem,
    carroceriasPreventivas: (state) => state.setCarroceriasPreventivas,
    setTotalCarroceriasAVencer: (state) => state.setTotalCarroceriasAVencer,
    setTotalCarroceriasVencidas: (state) => state.setTotalCarroceriasVencidas
  },

  actions: {
    async notificacao({ commit }, { nr_seq_os }) {
      const response = await api.post('checklist/notificacao?nr_seq_os=' + nr_seq_os)

      console.log(response)
      return response
    },

    async gerarPreventiva({ commit }, { data }){
      try{
        const response = api.post(`os/gerarPreventiva`, { ...data })

        return response
      }catch (error) {
        throw new Error(error)
      }
    }, 

    async gerarPreventivaExterna({ commit }, { data}){
      try{
        const response = api.post(`os/gerarPreventivaExterna`, { ...data })

        return response
      }catch (error) {
        throw new Error(error)
      }
    },

    async fetchFromApi ({ commit }, { nrSeqOs }) {
      commit('setItems', 'loading')
      try {
        const response = await api.get(`os/${nrSeqOs}/itens`)

        commit('setItems', response.data.items)
        return response
      } catch (error) {
        commit('setItems', [])
        throw new Error(error)
      }
    },

    async gerarPreventivaCarroceria({ commit }, { data }) {
      try {
        const response = await api.post('os/gerarPreventivaCarroceria', { ...data })

        return response
      } catch (error) {
        commit('setPlacasAVencer', [])
        throw new Error(error)
      }

    },

    async placasAVencer({ commit }, { stPreventiva }){
      // commit('setPlacasAVencer', 'loading')
      try {
        const response = await api.get(`os/itens/execucao/placasAVencer/${stPreventiva}`)

        if(stPreventiva == 'V'){
          commit('setTotalPlacasVencidas', response.data.length)
        } else {
          commit('setTotalplacasAVencer', response.data.length)
        }
        commit('setPlacasAVencer', response.data)
        return response
      } catch (error) {
        commit('setPlacasAVencer', [])
        throw new Error(error)
      }
    },

    async placasAVencerArmazem({ commit }, { stPreventiva }){
      // commit('setPlacasAVencer', 'loading')
      try {
        const response = await api.get(`os/itens/execucao/placasAVencerArmazem/${stPreventiva}`)

        if(stPreventiva == 'V'){
          commit('setTotalPlacasVencidasArmazem', response.data.length)
        } else {
          commit('setTotalplacasAVencerArmazem', response.data.length)
        }
        commit('setPlacasAVencer', response.data)
        return response
      } catch (error) {
        commit('setPlacasAVencer', [])
        throw new Error(error)
      }
    },

    async carroceriasPreventivas({ commit }, { stPreventivaCarroceria }){
      // commit('setPlacasAVencer', 'loading')
      try {
        const response = await api.post(`os/itens/execucao/carroceriasPreventivas/${stPreventivaCarroceria}`)

        if(stPreventivaCarroceria == 'A'){
          commit('setTotalCarroceriasAVencer', response.data.length)
        } else {
          commit('setTotalCarroceriasVencidas', response.data.length)
        }
        
        commit('setCarroceriasPreventivas', response.data)
        return response
      } catch (error) {
        commit('setCarroceriasPreventivas', [])
        throw new Error(error)
      }
    },

    async continuarPreventiva({commit}, { data }){
      try {
        const response = await api.post(`os/itens/execucoes/continuarPreventiva`, { ...data })

        return response
      } catch (error){
        throw new Error(error)
      }
    },

    async pausarPreventiva({ commit }, { data }){
      try {
        const response = await api.post(`os/itens/execucoes/pausarPreventiva`, { ...data })

        return response
      } catch (error) {
        throw new Error(error)
      }
    },

    async fetchFromApiPreventiva ({ commit }, { nrSeqOs }) {
      commit('setItemsPreventiva', 'loading')
      try {
        const response = await api.get(`os/${nrSeqOs}/itensPreventiva`)
        
        commit('setItemsPreventiva', response.data.items)
        return response
      } catch (error) {
        commit('setItemsPreventiva', [])
        throw new Error(error)
      }
    },

    async fetchItemFromApi ({ commit }, { nrSeqOs, nrSequencial }) {
      try {
        const response = await api.get(`os/${nrSeqOs}/itens/${nrSequencial}`)

        commit('setItem', response.data.item)
        
        return response
      } catch (error) {
        console.error(error)
        throw new Error(error)
      }
    },

    async gerarPreditiva({ commit }, { data }){
      try {
        const response = api.post(`os/gerarPreditiva`, { ...data })

        return response
      } catch (error) {
        throw new Error(error)
      }
    },
 
    async getPlacasPreditivas({ commit }, { data }) {
      try {

        const response = await api.post('os/getPlacasPreditivas', { ...data })
 
        return response
      } catch (error) {
        console.log(error)
      }
    },

    async fetchItemFromApiPreventiva ({ commit }, { nrSeqOs, nrSequencial }) {
      try {
        const response = await api.get(`os/${nrSeqOs}/itensPreventiva/${nrSequencial}`)

        commit('setItemPreventiva', response.data.item)
        
        return response
      } catch (error) {
        console.error(error)
        throw new Error(error)
      }
    },

    async getAllItens({ commit }){
      try {
        const response = await api.get('os/itens/getAllItens')

        commit('setAllItems', response.data)
        return response
      } catch (error){
        throw new Error(error)
      }
    },

    async getItens ({ commit }, { nrOs }){
      try{
        const response = await api.get(`os/getItens/${nrOs}`)

        return response
      } catch ( error ){
        console.log(error)
        throw new Error(error)
      }
    },

    async updatePeca ({ commit }, { data }) {
      try {
        const response = await api.put('os/itens/execucoes/updatePeca', { ...data })

        return response
      } catch (error) {
        console.log(error)
        throw new Error (error)
      }
    },

    async insertPeca ({ commit }, { data }) {
      try {
        const response = await api.post('os/itens/execucoes/insertPeca', { ...data })

        return response
      } catch (error) {
        throw new Error (error)
      }
    },

    async validaTravaEmpilhadeira ({ commit }, { data }) {
      try {
        const response = await api.post('os/itens/execucoes/validaTravaEmpilhadeira', { ...data })

        return response
      } catch (error) {
        throw new Error (error)
      }
    },


    async delete ({ commit }, { nrSeqOs, nrSequencial, nrSeqClifor }) {
      try {
        const response = await api.delete(`os/${nrSeqOs}/itens/${nrSequencial}`, { data: { nr_seq_clifor: nrSeqClifor } })

        commit('unsetItem', nrSequencial)
        return response
      } catch (error) {
        console.error(error)
        throw new Error(error)
      }
    },

    async create ({ commit }, { nrSeqOs, data }) {
      try {
        const response = await api.post(`os/${nrSeqOs}/itens`, data)

        return response
      } catch (error) {
        throw new Error(error)
      }
    },

    async update ({ commit }, { nrSeqOs, nrSequencial, data }) {
      try {
        const response = await api.put(`os/${nrSeqOs}/itens/${nrSequencial}`, data)

        return response
      } catch (error) {
        throw new Error(error)
      }
    },

    async getItensExec({ commit }, {nr_os}){
      try {
        const response = await api.get(`os/itens/execucao/getItensExec/${nr_os}`)

        return response.data
      } catch (error){
        console.log(error)
        throw new Error(error)
      }
    }
  },

  mutations: {
    setCarroceriasPreventivas(state, items){
      state.setCarroceriasPreventivas = items
    },
    
    setTotalCarroceriasAVencer(state, items) {
      state.setTotalCarroceriasAVencer = items
    },

    setTotalCarroceriasVencidas(state, items) {
      state.setTotalCarroceriasVencidas = items
    },

    setTotalplacasAVencer(state, items){
      state.totalplacasAVencer = items
    },

    setTotalplacasAVencerArmazem(state, items){
      state.totalplacasAVencerArmazem = items
    },

    setTotalPlacasVencidas(state, items){
      state.totalPlacasVencidas = items
    },

    setTotalPlacasVencidasArmazem(state, items){
      state.totalPlacasVencidasArmazem = items
    },

    setItems (state, items) {
      if (items === 'loading') {
        state.items = items
        return true
      }

      state.items = [
        ...items
      ]
    },
    
    setPlacasAVencer (state, placas){
      state.placas = placas
    },
    setItemsPreventiva (state, itemsPreventiva) {
      if (itemsPreventiva === 'loading') {
        state.itemsPreventiva = itemsPreventiva
        return true
      }

      state.itemsPreventiva = [
        ...itemsPreventiva
      ]
    },
    setExec (state, itemsExec){
      state.itemsExec = itemsExec
    },
    setItem (state, item) {
      const itemsList = [...state.items || []]

      const index = itemsList.findIndex(i => i.nr_sequencial === item.nr_sequencial)

      if (index >= 0) {
        itemsList[index] = item
      } else {
        itemsList.unshift(item)
      }

      state.items = [
        ...itemsList
      ]
    },
    setItemPreventiva (state, itemsPreventiva) {
      const itemsList = [...state.itemsPreventiva || []]

      const index = itemsList.findIndex(i => i.nr_sequencial === itemsPreventiva.nr_sequencial)

      if (index >= 0) {
        itemsList[index] = itemsPreventiva
      } else {
        itemsList.unshift(itemsPreventiva)
      }

      state.itemsPreventiva = [
        ...itemsList
      ]
    },
    unsetItem (state, nrSequencial) {
      const itemsList = [...state.items || []]

      const filteredItems = itemsList.filter(i => i.nr_sequencial !== nrSequencial)

      state.items = [
        ...filteredItems
      ]
    },
    setAllItems (state, { item }) {
      state.allItems = { ...item }
    },
    setEditing (state, { item }) {
      state.editing = { ...item }
    }
  }
}
